import { getFileTypeName, getTypesAll } from '../../../../utils';
import { isCategoryInList } from '../../../../utils/category-utils';
import { getDateRangeForFilter } from '../../../../services';

/**
 * Filtreleme işlemleri için metodları oluşturur
 * 
 * @returns {Object} - Filtreleme metodları
 */
export const createFilterMethods = () => {
  /**
   * Dosya türüne göre filtreleme
   * @param {Array} docs - Filtrelenecek belgeler
   * @param {string|number} fileType - Filtre türü
   * @returns {Array} - Filtrelenmiş belgeler
   */
  const filterByFileType = (docs, fileType) => {
    // getTypesAll fonksiyonunu import ederek tür listesini al
    const allTypes = getFileTypeName ? getTypesAll() : [];

    // Seçilen türü bul
    const selectedType = allTypes.find(type => type.value === String(fileType));

    if (selectedType) {
      return docs.filter(doc => {
        // Filtre için doc.typeId kullan - bu veritabanı alanıdır
        return Number(doc.typeId) === Number(selectedType.value);
      });
    }

    return docs;
  };

  /**
   * Kategoriye göre filtreleme
   * @param {Array} docs - Filtrelenecek belgeler
   * @param {Array} categoryIds - Kategori IDleri
   * @returns {Array} - Filtrelenmiş belgeler
   */
  const filterByCategory = (docs, categoryIds) => {
    return docs.filter(doc =>
      doc.categories &&
      doc.categories.some(category =>
        isCategoryInList(categoryIds, category.id),
      ),
    );
  };

  /**
   * Tarihe göre filtreleme
   * @param {Array} docs - Filtrelenecek belgeler
   * @param {string} dateFilter - Tarih filtresi
   * @returns {Array} - Filtrelenmiş belgeler
   */
  const filterByDate = (docs, dateFilter) => {
    const dateRange = getDateRangeForFilter(dateFilter);
    if (dateRange && dateRange.startDate && dateRange.endDate) {
      return docs.filter(doc => {
        // API'den dönen tarih formatı "2025-04-04 05:49" şeklinde
        // Önce boşlukları temizle ve sadece tarih kısmını al
        const docDateStr = doc.addDate.split(' ')[0];
        return docDateStr >= dateRange.startDate && docDateStr <= dateRange.endDate;
      });
    }
    return docs;
  };

  /**
   * Arama terimine göre filtreleme
   * @param {Array} docs - Filtrelenecek belgeler
   * @param {string} query - Arama terimi
   * @returns {Array} - Filtrelenmiş belgeler
   */
  const filterBySearchQuery = (docs, query) => {
    const searchTerm = query.toLowerCase();
    return docs.filter(doc =>
      (doc.fileName && doc.fileName.toLowerCase().includes(searchTerm)) ||
      (doc.description && doc.description.toLowerCase().includes(searchTerm)),
    );
  };

  return {
    filterByFileType,
    filterByCategory,
    filterByDate,
    filterBySearchQuery
  };
};